import LoginDialog from "components/Primary/LoginDialog";
import { useState } from "react";
import "./style.scss";

const ConnectWallet = ({}) => {

  const [walletPopup, setWalletPopup] = useState(false);


  return <>
    <div className="connectWalletWrapper" onClick={() => setWalletPopup(true)}>
      Connect Wallet
    </div>
    
    {
      walletPopup &&
      <LoginDialog open={walletPopup} onClose={() => setWalletPopup(false)}/>
    }
    
  </>
}
export default ConnectWallet;